<template>
  <Modal
    :open="displayModal"
    title="Error Information"
    size="large"
    :showEscapeButton="true"
    :showAcceptButton="false"
    :showDangerButton="false"
    @close="displayModal = false"
    ref="modal"
  >
    <div class="grid grid-cols-2 gap-4" v-if="selectedError !== null">
      <div class="col-span-1" v-if="selectedError.user !== undefined">
        <span class="block text-sm font-medium text-gray-700">Users Name</span>
        {{ selectedError.user.name }}
      </div>
      <div class="col-span-1">
        <span class="block text-sm font-medium text-gray-700"
          >Email Address</span
        >
        {{ selectedError.email_address }}
      </div>
      <div class="col-span-2">
        <span class="block text-sm font-medium text-gray-700">Feedback ID</span>
        {{ selectedError.feedback_id }}
      </div>
      <div class="col-span-2">
        <span class="block text-sm font-medium text-gray-700"
          >Diagnostic Code</span
        >
        <pre
          class="bg-gray-800 px-4 py-3 whitespace-normal text-white rounded-md mt-1"
          >{{ selectedError.diagnostic_code }}</pre
        >
      </div>
      <div class="col-span-1">
        <span class="block text-sm font-medium text-gray-700">Bounce Type</span>
        {{ selectedError.bounce_type }}
      </div>
      <div class="col-span-1">
        <span class="block text-sm font-medium text-gray-700">Status</span>
        {{ selectedError.status }} ({{ selectedError.mailDescription.message }})
      </div>
      <div class="col-span-1">
        <span class="block text-sm font-medium text-gray-700"
          >AWS Event Time</span
        >
        {{ selectedError.aws_timestamp | displayLocalDateTime }}
      </div>
      <div class="col-span-1">
        <span class="block text-sm font-medium text-gray-700"
          >CDN Ingest Time</span
        >
        {{ selectedError.created_at | displayLocalDateTime }}
      </div>
    </div>
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";
export default {
  components: { Modal },
  props: {
    selectedError: {
      default: {}
    }
  },
  data() {
    return {
      displayModal: false
    };
  },
  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on("admin-error-email-details-modal-open", this.open);
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-error-email-details-modal-open", this.open);
  },

  methods: {
    open(data) {
      console.log(this.selectedError);
      this.displayModal = true;
    }
  }
};
</script>
